module.exports = __webpack_public_path__ + "static/media/glam-popup.fa33b66c.svg";